import React from 'react';
import { TriangleAlert } from 'lucide-react';
import { Modal } from '../../../components/modal';
import { ActionButton } from '../../../components/buttons';
import { palette } from '../../../components/theme';

type ExportFailedModalProps = {
  title: string;
  reason?: string;
  onDismiss: () => void;
};

/**
 * Stays up until dismissed. A toast would expire while the tab is hidden, before
 * anyone is there to read it.
 */
export const ExportFailedModal: React.FC<ExportFailedModalProps> = ({ title, reason, onDismiss }) => (
  <Modal open>
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, padding: '8px 8px 0' }}>
      <TriangleAlert size={40} color={palette.primitives.orange.orange500} />

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
        <span
          style={{
            fontSize: 18,
            fontWeight: 700,
            color: palette.primitives.slate.slate900,
            textAlign: 'center'
          }}
        >
          {title}
        </span>
        {reason && (
          <span
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: palette.primitives.slate.slate500,
              textAlign: 'center',
              lineHeight: 1.45
            }}
          >
            {reason}
          </span>
        )}
      </div>

      <ActionButton variant='primary' onClick={onDismiss}>
        Entendido
      </ActionButton>
    </div>
  </Modal>
);
